import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #002666;
  justify-content: center;

  @media (max-width: 768px) {
      width: 500px;
  }


  .signup-form-holder {
    position: relative;
    border: solid gray 2px;
    border-radius: 10px;
    width: 60%;
    margin: 50px auto;
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f9f9f9;

    @media (max-width: 768px) {
      width: 400px;
  }
  }

  .header-container {
    height: 10%;
    width: 80%;
    border-bottom: 2px gray solid;
    color: #002666;
    font-size: 26px;
    i {
      font-size: 36px;
      margin-right: 10px;
      margin-left: 20px;
      color: #002666;
    }
  }

  .transaction-container {
    width: 100%;
    height: 65%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .transaction-image {
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }

  .transaction-image img {
    max-height: 370px;
    height: 50%;
    max-width: 100%;
    overflow: hidden;
    border-radius: 15px;
  }
  .transaction-data {
    margin-right: 25px;
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 95%;
    text-align: right;
    background-color: #d3d3d3;
    border-radius: 15px;
    padding: 25px 15px 25px 15px;
    font-family: 'Roboto', sans-serif;
  }

  .button-container {
    height: 10%;
    padding: 50px;
    margin-bottom: 20px;
  }

  button {
    border: none;
    padding: 10px 40px;
    background: #ce1720;
    color: #fff;
    border-radius: 10px;
    font-size: 24px;
    font-weight: bold;
    /* position:absolute;
            bottom: 0;
            right: 50; */
    margin-bottom: 15px;
  }
`;
